<template>
  <div class="edit-mtga-submission">
    <label>
      <h3>Title</h3>
      <input
        type="text"
        v-model="value.title" placeholder="Title" />
    </label>
    <label>
      <h3>Deck list</h3>
      <textarea
        v-model="value.list"
        placeholder="Deck list"
        rows="15"
        cols="50"></textarea>
      <br />
      <small>Must be MTGA formatted, cards separated by a new line.</small>
    </label>
    <label>
      <h3>Description</h3>
      <textarea
        v-model="value.description"
        placeholder="Description"
        rows="7"
        cols="50"></textarea>
    </label>
  </div>
</template>

<script>
export default {
  name: 'EditMTGASubmission',
  props: {
    value: {
      type: Object,
      default () {
        return {
          title: '',
          list: '',
          description: ''
        }
      }
    }
  },
  // data () {
  //   return {
  //     title: '',
  //     list: '',
  //     description: ''
  //   }
  // }
}
</script>

<style scoped>
</style>
